module.exports = __webpack_public_path__ + "static/media/19ESCAP29.068755a1.jpg";